import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterCustomer} from '../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterCustomer: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterCustomer({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Code')}
          value={filter?.customer_code ?? ''}
          onChange={({target}) => handleFilterChange({customer_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Name')}
          value={filter?.name ?? ''}
          onChange={({target}) => handleFilterChange({name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Account Group')}
          value={filter?.customer_account_group ?? ''}
          onChange={({target}) => handleFilterChange({customer_account_group: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('text')}
          value={filter?.text ?? ''}
          onChange={({target}) => handleFilterChange({text: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Company Type')}
          value={filter?.company_type ?? ''}
          onChange={({target}) => handleFilterChange({company_type: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Company Type Description 2')}
          value={filter?.company_type_description ?? ''}
          onChange={({target}) => handleFilterChange({company_type_description: target.value})}
        />
      </td>
      <td className='td-order-4 text-center pm-0'>
        <TextInputV2
          placeholder={t('Address')}
          value={filter?.street1 ?? ''}
          onChange={({target}) => handleFilterChange({...filter, street1: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('No Telp')}
          value={filter?.no_telp ?? ''}
          onChange={({target}) => handleFilterChange({no_telp: target.value})}
        />
      </td>
      <td className='td-order-4 text-center pm-0'>
        <TextInputV2
          placeholder={t('Email')}
          value={filter?.email ?? ''}
          onChange={({target}) => handleFilterChange({email: target.value})}
        />
      </td>
    </TRowFilter>
  )
})
